import { Routes } from 'react-router-dom';
import { buildRoutes } from '../components/RouteBuilder';
import { RootRoutes } from './RootRoutes';
import { ApplicantRoutes } from './ApplicantRoutes';
import { FunctionaryRoutes } from './FunctionaryRoutes';
import { NPSRoutes } from './NPSRoutes';
import { PreworkRoutes } from './PreworkRoutes';

const AppRoutes = () => {
	const allRoutes = [
		...RootRoutes,
		...ApplicantRoutes,
		...FunctionaryRoutes,
		...NPSRoutes,
		...PreworkRoutes,
	];

	return <Routes>{buildRoutes(allRoutes)}</Routes>;
};

export default AppRoutes;
